import { render, staticRenderFns } from "./CompanyEventList.vue?vue&type=template&id=6c6bd8c4&scoped=true"
import script from "./CompanyEventList.vue?vue&type=script&lang=js"
export * from "./CompanyEventList.vue?vue&type=script&lang=js"
import style0 from "./CompanyEventList.vue?vue&type=style&index=0&id=6c6bd8c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6bd8c4",
  null
  
)

export default component.exports